import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import axios from "axios";
import { Helmet } from "react-helmet";
import { subscribe } from "../../assets/images";
import DiscountProductsKampaniya from "./DiscountProductsKampaniya/DiscountProductsKampaniya";

const Kampaniya = () => {
  const [list, setItems] = useState([]);

  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language; // Aktif dili alıyoruz

  const [showModal, setShowModal] = useState(false);
  const [single, setSingle] = useState(null); 

  const closeModal = () => {
    setShowModal(false); 
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowModal(true);
    }, 5000); // 5 saniye sonra modal göster

    return () => clearTimeout(timer); // Sayfa değişirse veya bileşen unmount olursa timer temizlensin
  }, []);

  useEffect(() => {
    getProducts();
    getSeoTags();
  }, []);

  const getProducts = async () => {
    try {
      const response = await axios.get(
        `https://www.elzabeauty.az/elza/kampaniya.php`,
        { withCredentials: false }
      );
      setItems(response.data.data);
    } catch (error) { 
      console.error("Error fetching products:", error);
    }
  };

  const getSeoTags = async () => {
    try {
      const response = await axios.get(
        "https://www.elzabeauty.az/elza/seoTagsKampaniya.php"
      );
      const data = response.data.data || [];

      setSingle(data[0]);
    } catch (error) {
      console.error("Error fetching products:", error);
    }
  };

  const getLocalizedField = (item, fieldBase) => {
    if (currentLanguage === "en")
      return item[`${fieldBase}En`] || item[fieldBase];
    if (currentLanguage === "ru")
      return item[`${fieldBase}Ru`] || item[fieldBase];
    return item[fieldBase]; // default: az
  };

  return (
    <>
      {single && (
        <Helmet>
          <title>{getLocalizedField(single, "meta_tag_title")}</title>
          <meta
            name="description"
            content={getLocalizedField(single, "meta_tag_description")}
          />
          <meta
            name="keywords"
            content={getLocalizedField(single, "meta_tag_keywords")}
          />
        </Helmet>
      )}
      <div>
        <div className="max-w-containerSm md:max-w-container mx-auto">
          <div className="mt-10">
            {list.length > 0 && (
              <div
                style={{
                  backgroundImage: `url(${subscribe})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  height: window.innerWidth < 640 ? "200px" : "344px",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  textAlign: "center",
                  borderRadius: "4px",
                }}
              >
                <p className="text-center text-[24px] md:text-[32px] font-semibold text-white">
                  {getLocalizedField(list[0], "title")}
                </p>
                <p
                  className="text-center text-white text-[14px] md:text-[16px] mt-3 md:w-[460px]"
                  dangerouslySetInnerHTML={{
                    __html: getLocalizedField(list[0], "content"),
                  }}
                ></p>
              </div>
            )}
          </div>
          <div>
            <DiscountProductsKampaniya />
          </div>
        </div>

        {/* {showModal && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
            <div className="relative bg-[white] rounded-[20px] py-[32px] md:py-[53px] px-[19px] md:px-[60px] w-[343px] md:w-[646px] shadow-lg">
              <button
                onClick={closeModal}
                className="absolute top-2 right-4 text-gray-500 hover:text-black text-[30px]"
              >
                &times;
              </button>

              <h2 className="text-[18px] font-bold text-firstColor text-center">
                {" "}
                {t("Kampaniyadan Yararlanmaq Şansı!")}
              </h2>
              <p className="mt-6 text-firstColor text-center text-[14px] md:text-[16px]">
                {t(
                  "Sənin üçün xüsusi təklifimiz var! Bu fürsəti qaçırmamaq üçün indi müraciət et və kampaniyanın üstünlüklərindən yararlan."
                )}
              </p>
            </div>
          </div>
        )} */}
      </div>
    </>
  );
};

export default Kampaniya;
